import './sass/app.scss';
import '@popperjs/core';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import { Provider } from "react-redux";
import store from "./js/store";
import ProductPlanningContainer from './js/containers/ProductPlanningContainer';

function App() {
  return (
    <Provider store={store}>
      <ProductPlanningContainer />
    </Provider>
  );
}

export default App;
